import { Pipe, PipeTransform, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  standalone: false,
  name: 'orderPallets'
})
export class OrderPalletsPipe implements PipeTransform {

  constructor(
      @Inject(TranslateService) private translate: TranslateService
  ) {}

  transform(orderPackagesRef: any[], enableSuffix: boolean): string | number {
    let sum = 0;

    if (orderPackagesRef) {
      sum = orderPackagesRef.reduce((acc, item) => {
        if (item.pallets) {
          acc += (item.pallets || 0);
          // acc += (item.pallets * (item.count || 1));
        }
        return acc;
      }, 0);
    }

    return enableSuffix
        ? this.translate.instant(sum === 1 ? 'X_PALLET' : 'X_PALLETS', { sum: sum })
        : sum;
  }
}
